// Test API connections and environment variables
export const testAPI = () => {
  return {
    domain: process.env.REACT_APP_API_DOMAIN,
    isSimulation: process.env.REACT_APP_IS_SIMULATION === 'true',
    endpoints: {
      register: process.env.REACT_APP_REGISTER_API,
      login: process.env.REACT_APP_LOGIN_API,
      upload: process.env.REACT_APP_UPLOAD_DOCUMENT_API,
      process: process.env.REACT_APP_PDF_PROCESSING_API
    }
  };
};

// Test function to simulate API calls (for when backend is not available)
export const simulateAPI = async (endpoint, method = 'GET', data = null) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Simulate different responses based on endpoint
  if (endpoint.includes('/auth/login')) {
    return {
      accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4NjgzOGE2NWRhOWMwMThjMWZmMWExNiIsImNvbXBhbnlJZCI6IjY4NjgzOGE1NWRhOWMwMThjMWZmMWExNCIsInJvbGUiOiJhZG1pbiIsImlzQ29tcGFueUFzc2lnbmVkIjpmYWxzZSwiaWF0IjoxNzUxNjYwNzY5LCJleHAiOjE3NTIyNjU1Njl9.simulation_token",
      refreshToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.simulation_refresh_token",
      tokenFamily: "550e8400-e29b-41d4-a716-446655440000",
      user: {
        id: "686838a65da9c018c1ff1a16",
        email: data.email,
        firstName: "Test",
        lastName: "User",
        phoneNumber: "+1234567890",
        companyId: "686838a65da9c018c1ff1a14",
        role: "Admin",
        isCompanyAssigned: true,
        trialStartDate: "2024-01-01T00:00:00.000Z",
        company: {
          name: "Test Company",
          companyType: "contractor"
        }
      },
      subscriptionType: "Premium",
      subscription: {
        name: "Premium",
        activatedAt: "2024-01-01T00:00:00.000Z",
        expiresAt: "2024-12-31T23:59:59.000Z",
        subscription: {
          name: "Premium",
          limits: {
            pdfUploads: 100,
            chatMessages: 1000
          }
        }
      }
    };
  }
  
  if (endpoint.includes('/auth/register')) {
    return {
      id: "686838a65da9c018c1ff1a16",
      companyId: "686838a55da9c018c1ff1a14", 
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      passwordHash: "$2b$10$simulation_password_hash",
      role: "admin",
      trialStartDate: new Date().toISOString(),
      subscriptionStatus: "trial",
      isCompanyAssigned: false
    };
  }

  // Google OAuth endpoints
  if (endpoint.includes('/auth/google/login') || endpoint.includes('/auth/google')) {
    return {
      accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.google_oauth_simulation_token",
      refreshToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.google_oauth_refresh_token",
      tokenFamily: "550e8400-e29b-41d4-a716-446655440001",
      user: {
        id: "google_user_" + Date.now(),
        email: "googleuser@gmail.com",
        firstName: "Google",
        lastName: "User",
        phoneNumber: null,
        companyId: "google_company_" + Date.now(),
        role: "Admin",
        isCompanyAssigned: true,
        trialStartDate: "2024-01-01T00:00:00.000Z",
        company: {
          name: "Google Company",
          companyType: "other"
        }
      },
      subscriptionType: "Premium",
      subscription: {
        name: "Premium",
        activatedAt: "2024-01-01T00:00:00.000Z",
        expiresAt: "2024-12-31T23:59:59.000Z",
        subscription: {
          name: "Premium",
          limits: {
            pdfUploads: 100,
            chatMessages: 1000
          }
        }
      }
    };
  }

  if (endpoint.includes('/auth/google/signup')) {
    return {
      id: "google_signup_" + Date.now(),
      companyId: "google_company_" + Date.now(),
      firstName: "Google",
      lastName: "User", 
      email: "googleuser@gmail.com",
      phoneNumber: data.phoneNumber || null,
      companyName: data.companyName || "Google Company",
      companyType: data.companyType || "other",
      passwordHash: null,
      role: "admin",
      trialStartDate: new Date().toISOString(),
      subscriptionStatus: "trial",
      isCompanyAssigned: false,
      authProvider: "google"
    };
  }

  // Refresh token endpoint
  if (endpoint.includes('/auth/refresh-token')) {
    return {
      accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.refreshed_simulation_token",
      refreshToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.refreshed_simulation_refresh_token",
      tokenFamily: "550e8400-e29b-41d4-a716-446655440002"
    };
  }
  
  if (endpoint.includes('/pdf/upload')) {
    return {
      success: true,
      fileId: 'file-' + Date.now(),
      filename: 'uploaded-document.pdf',
      size: 1024000
    };
  }
  
  if (endpoint.includes('/pdf/process')) {
    return {
      success: true,
      processId: 'process-' + Date.now(),
      status: 'completed',
      results: {
        compliance_score: 85,
        issues_found: 3,
        standards_checked: ['AS3000'],
        summary: 'Document complies with most AS3000 requirements. 3 minor issues identified.'
      }
    };
  }

  // Handle document processing with path parameter  
  if (endpoint.includes('/api/pdf/process/') && method === 'POST') {
    // Extract documentId from path parameter
    const documentId = endpoint.split('/api/pdf/process/')[1];
    
    return {
      success: true,
      processId: 'process-' + Date.now(),
      documentId: documentId,
      metadataId: 'metadata-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
      status: 'completed',
      results: {
        compliance_score: 85,
        issues_found: 3,
        standards_checked: ['AS3000'],
        summary: `Document ${documentId} complies with most AS3000 requirements. 3 minor issues identified.`
      }
    };
  }

  // Handle document deletion
  if (endpoint.includes('/api/pdf/documents/') && method === 'DELETE') {
    // Extract documentId from path parameter
    const documentId = endpoint.split('/api/pdf/documents/')[1];
    
    return {
      success: true,
      message: `Document ${documentId} deleted successfully`,
      deletedDocumentId: documentId
    };
  }
  // Handle metadata deletion
  if (endpoint.includes('/api/pdf/metadata/') && method === 'DELETE') {
    // Extract metadataId from path parameter
    const metadataId = endpoint.split('/api/pdf/metadata/')[1];
    
    return {
      success: true,
      message: `Metadata ${metadataId} deleted successfully`,
      deletedMetadataId: metadataId
    };
  }

  // Handle getting metadata/clauses for a specific document
  if (endpoint.includes('/api/pdf/clauses/') && method === 'GET') {
    // Extract documentId from path parameter
    const documentId = endpoint.split('/api/pdf/clauses/')[1];
    
    // Return mock response that matches the real API format with wrapper structure
    return {
      metadata: {
        _id: "686a6c87f798de6cf24e4839",
        documentId: documentId,
        companyId: "6868477376fd83126ca87af3",
        userId: "6868477376fd83126ca87af5",
        metadataId: "686a6c84f798de6cf24e4837",
        pdfFileName: "AS3000.pdf",
        clausesCount: 415,
        clausesFilePath: "D:\\Projects\\RAGbackend1\\processed\\6868477376fd83126ca87af3\\clauses-686a6c84f798de6cf24e4837-2025-07-06T12-31-03-182Z.json",
        createdAt: "2025-07-06T12:31:03.191Z",
        updatedAt: "2025-07-06T12:31:03.191Z",
        __v: 0,
        // Add mock extracted clauses for UI display
        extractedClauses: [
          {
            id: "clause_1",
            section: "2.1",
            title: "General Electrical Installation Requirements",
            content: "All electrical installations must comply with AS/NZS 3000:2018 standards and local regulations.",
            compliance: "compliant",
            risk: "low",
            recommendations: ["Regular inspection required", "Documentation must be maintained"]
          },
          {
            id: "clause_2", 
            section: "2.2",
            title: "Safety Requirements",
            content: "Safety switches and circuit breakers must be installed and tested according to manufacturer specifications.",
            compliance: "partially-compliant",
            risk: "medium",
            recommendations: ["Update testing procedures", "Install additional safety equipment"]
          },
          {
            id: "clause_3",
            section: "2.3", 
            title: "Earthing and Bonding",
            content: "All metallic parts must be properly earthed and bonded to prevent electrical hazards.",
            compliance: "non-compliant",
            risk: "high",
            recommendations: ["Immediate remediation required", "Professional inspection needed", "Update earthing system"]
          }
        ],
        analysisResults: {
          complianceScore: 78,
          compliantClauses: 1,
          partiallyCompliantClauses: 1,
          nonCompliantClauses: 1,
          totalClauses: 3,
          riskAssessment: "medium"
        }
      },
      clausesData: null // This endpoint doesn't return clauses data, just metadata
    };
  }

  // Handle getting metadata (old endpoint - kept for backward compatibility)
  if (endpoint === '/api/pdf/metadata' && method === 'GET') {
    return [
      {
        id: "686a4d1fba1298c8631a069a",
        documentId: "686850a45a8cfa41b528f91b",
        originalName: "AS3000.pdf",
        extractedText: "Sample extracted text from AS3000 document...",
        analysisResults: {
          compliance: "AS3000",
          issues: ["Section 2.1 requires update", "Missing clause 4.5"],
          score: 85
        },
        processedAt: "2025-07-05T14:30:00.000Z",
        processedBy: "6868477376fd83126ca87af5",
        companyId: "6868477376fd83126ca87af3"
      },
      {
        id: "686a4e2cba1298c8631a069b",
        documentId: "6868f823d71974e150f587c2",
        originalName: "Technical_Manual.pdf",
        extractedText: "Technical manual content with specifications...",
        analysisResults: {
          compliance: "AS3000",
          issues: ["Figure 3.2 needs revision"],
          score: 92
        },
        processedAt: "2025-07-05T15:45:00.000Z",
        processedBy: "6868477376fd83126ca87af5",
        companyId: "6868477376fd83126ca87af3"
      }
    ];
  }

  return { success: true, message: 'API call simulated successfully' };
};
